import { render, staticRenderFns } from "./QuickviewKeyword.vue?vue&type=template&id=2b66f6a7&scoped=true&"
import script from "./QuickviewKeyword.vue?vue&type=script&lang=js&"
export * from "./QuickviewKeyword.vue?vue&type=script&lang=js&"
import style0 from "./QuickviewKeyword.vue?vue&type=style&index=0&id=2b66f6a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b66f6a7",
  null
  
)

export default component.exports